import React, { useState } from 'react';
 import './MontessoriGrid.css'; // Assume Tailwind or custom CSS
import { useEffect } from 'react';
import SuperActivityService from "./Locality/Service/superActivityService"
import StudentService from "./Locality/Service/studentService"
import ActivityService from "./Locality/Service/activityService";
import PageTitle from "../../components/PageTitle/PageTitle";


const statusColors = {
  M: 'bg-green-600', // Mastered
  P: 'bg-blue-500',  // Practicing
  N: 'bg-orange-400', // Needs Help
  F: 'bg-black',      // Flagged
  '': 'bg-gray-200'   // Empty
};

const ActivityReport = () => {
        const [activityList, setActivityList] = useState([]);
      const [studentsList, setstudentsList] = useState([]);
    const areas = [
  {
    name: "Numbers 1-10",
    students: ["Tim G", "Ian G", "Gretchen S", "Hana F", "Frank T"],
    activities: [
      {
        name: "Number Rods",
        status: ["M", "M", "M", "M", "M"],
        subActivities: [
          {
            name: "Introduction to Quantity",
            status: ["M", "M", "M", "M", "M"]
          },
          {
            name: "Games with Quantities",
            status: ["M", "M", "M", "M", "P"]
          }
        ]
      }
    ]
  }
  
];
const data = [
  {
    subject: "Math",
    students: ["Tim G", "Ian G", "Gretchen S", "Hana F", "Frank T"],
    activities: [
      {
        name: "Number Rods",
        status: ["M", "M", "M", "M", "M"],
        subActivities: [
          {
            name: "Introduction to Quantity",
            status: ["M", "M", "M", "M", "M"]
          },
          {
            name: "Games with Quantities",
            status: ["M", "M", "M", "M", "P"]
          }
        ]
      },
       {
        name: "Number fdfd",
        status: ["M", "M", "M", "M", "M"],
        subActivities: [
        ]
      }
    ]
  },
  {
    subject: "Language",
   students: ["Tim G", "Ian G", "Gretchen S", "Hana F", "Frank T"],
    activities: [
      {
        name: "Number Rods",
        status: ["M", "M", "M", "M", "M"],
        subActivities: [
          {
            name: "Introduction to Quantity",
            status: ["M", "M", "M", "M", "M"]
          },
          {
            name: "Games with Quantities",
            status: ["M", "M", "M", "M", "P"]
          }
        ]
      }
    ]
  }
];
    const [addSuperActivityList, setAddSuperActivityList] = useState([]);
    const [studentList, setStudentList] = useState([]);
  var [isLoading, setIsLoading] = useState(false);

 const [activeTab, setActiveTab] = useState('');
  useEffect(() => {
    
      getSuperActivityList();
      getStudentList();
      
        return () => {
           setStudentList([]);
            setAddSuperActivityList([]);
         setActivityList([]);
        }
    }, []);
const colorMap = {
  "P": "#17875f",         
  "WI": "#FF9800",       
  "WA": "#FFD700",       
};
    const onSubmit = (data) => {
  setIsLoading(true); // Start loading

  const userDetails = JSON.parse(localStorage.getItem("userDetail"));

  const keys = {
    schooleId: "6808b94a822b50006496a46b",
    isFuturePlanning: false,
    isInitLoad: true,
    superActivityId: data,
    studentId: "",
    classId: "",
    startDate: "",
    endDate: "",
    status: true
  };

  ActivityService.findActivityReports(keys)
    .then((result) => {
      setActivityList(result);

      const allStudents = [];
            const allActivities  = [];
      result.forEach(activity =>
        activity.activityList.forEach(rec => {
          const student = rec.studentId;
          if (student && !allStudents.find(s => s._id === student._id)) {
            allStudents.push(student);
          }
        })
      );
      setstudentsList(allStudents);
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      setIsLoading(false); // End loading
    });
};


  const getSuperActivityList = async () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));
  try {
    const res = await SuperActivityService.getAllSuperActivityById(userDetails.schooleId);
    setAddSuperActivityList(res);

    if (res.length > 0) {
      setActiveTab(res[0]._id);       
      onSubmit(res[0]._id);          
    }
  } catch (err) {
    console.error(err);
  }
};
         const getStudentList = (event, obj) => {
                const userDetails = JSON.parse(localStorage.getItem("userDetail"));
             
        
        
                StudentService.getAllStudentById(userDetails.schooleId, 
                ).then((res) => {
                    let studentDetails = res.map(res => {
                        return { _id: res._id, studentName: `${res.firstName} ${res.lastName}`, status: true };
                    });
        
                    setStudentList(studentDetails);
        
                    
                }).catch((err) => {
                    // setError(err.message);
                });
            }
  const handleTabClick = (superActivityId) => {
    
    setActiveTab(superActivityId);
    onSubmit(superActivityId);
  };
 
  return (
    <>
     <PageTitle title="Activity Status" />
    <br></br>
    <div className="overflow-x-auto activity-record p-4 space-y-6">
        <div>
        <h2 className="text-xl font-bold mb-2 text-gray-700">Area Of Work</h2>
       
      </div>
       <br></br>
      <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
  <div style={{ display: 'inline-flex', gap: '10px', paddingBottom: '10px' }}>
    {addSuperActivityList.map((area) => {
      const isActive = activeTab === area._id;
      return (
        <button
          key={area._id}
          onClick={() => handleTabClick(area._id)}
          style={{
            padding: '10px 16px',
            borderBottom: isActive ? '3px solid rgb(15 59 98)' : '3px solid transparent',
            backgroundColor: isActive ? '#DBEAFE' : 'transparent',
            color: isActive ? 'rgb(15 59 98)' : '#4B5563',
            fontWeight: '600',
            borderRadius: '6px 6px 0 0',
            whiteSpace: 'nowrap', 
            cursor: 'pointer'
          }}
        >
          {area.superActivityName}
        </button>
      );
    })}
  </div>
</div>
<br></br>
      {isLoading ? (
  <div className="text-center p-4 text-blue-600">Loading data...</div>
) : (
    <div style={{ overflowX: "auto" }}>
<table border="1" cellPadding="8" style={{ borderCollapse: "collapse", minWidth: "800px", width: "max-content"}}>
      <thead>
        <tr>
          <th style={{width:'500px'}}>Activity</th>
          {studentsList.map(student => (
            <th key={student._id} style={{width:'100px'}}>
              {student.firstName?.toUpperCase()} {student.lastName?.toUpperCase()}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {activityList.map(activity => (
          <tr key={activity.id}>
            <td 
            style={{
         backgroundColor: "#F3F4F6",   
    fontWeight: "bold",
    color: "#111827",             
    textAlign: "left",
    width: "200px",               
    wordWrap: "break-word",      
    whiteSpace: "normal",         
    padding: "8px",               
    verticalAlign: "top",         
        }}
        >
            {activity.activityName}
        </td>
            {studentsList.map(student => {
              const record = activity.activityList.find(
                r => r.studentId && r.studentId._id === student._id
              );
              const key = record?.activityRecordsId[0]?.key;
              const bgColor = colorMap[key] || "transparent";

              return (
                 <td
      key={student._id}
      style={{
        backgroundColor: bgColor,
        textAlign: "center",
        fontWeight: "bold"
      }}
      title={key}
    >
      {key || "-"}
    </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
    </div>
)}
     
    </div>
    </>
  );
};

export default ActivityReport;




